module.exports = __webpack_public_path__ + "static/media/service_online_5.5697baf7.png";